import { render, staticRenderFns } from "./addHoliday.vue?vue&type=template&id=64b5172b&scoped=true&"
import script from "./addHoliday.vue?vue&type=script&lang=js&"
export * from "./addHoliday.vue?vue&type=script&lang=js&"
import style0 from "./addHoliday.vue?vue&type=style&index=0&id=64b5172b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5172b",
  null
  
)

export default component.exports